var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isFieldErrorsValid, NoFieldError } from "../validation/validatableentity";
function getEntityField(state, field, default$) {
    if (default$ === void 0) { default$ = null; }
    var field_path = field.split('.');
    var draft_item = state.entity;
    for (var _i = 0, field_path_1 = field_path; _i < field_path_1.length; _i++) {
        var field_item = field_path_1[_i];
        if (field_item.endsWith(']')) {
            var field_subpath = field_item.replace(']', '').split('[');
            draft_item = draft_item[field_subpath[0]];
            draft_item = draft_item[field_subpath[1]];
        }
        else {
            draft_item = draft_item[field_item];
        }
        if (draft_item == null) {
            break;
        }
    }
    return draft_item == null ?
        default$ :
        draft_item;
}
function getStateField(state, field, default$) {
    if (default$ === void 0) { default$ = null; }
    var field_path = field.split('.');
    var draft_item = state;
    for (var _i = 0, field_path_2 = field_path; _i < field_path_2.length; _i++) {
        var field_item = field_path_2[_i];
        if (field_item.endsWith(']')) {
            var field_subpath = field_item.replace(']', '').split('[');
            draft_item = draft_item[field_subpath[0]];
            draft_item = draft_item[field_subpath[1]];
        }
        else {
            draft_item = draft_item[field_item];
        }
        if (draft_item == null) {
            break;
        }
    }
    return draft_item == null ?
        default$ :
        draft_item;
}
function setFieldNotValidate(draft_state, field, value) {
    var field_path = field.split('.');
    var field_path_len = field_path.length;
    if (field_path_len === 0) {
        return;
    }
    var last_field_index = field_path_len - 1;
    var draft_item = draft_state;
    for (var i = 0; i < last_field_index; ++i) {
        var field_item = field_path[i];
        if (field_item.endsWith(']')) {
            var field_subpath = field_item.replace(']', '').split('[');
            draft_item = draft_item[field_subpath[0]];
            draft_item = draft_item[field_subpath[1]];
        }
        else {
            draft_item = draft_item[field_item];
        }
        if (draft_item == null) {
            break;
        }
    }
    if (draft_item != null) {
        var field_item = field_path[last_field_index];
        draft_item[field_item] = value;
    }
}
function validateAndTestIfStore(draft_errors, field, value, validator, storeInvalidValue) {
    if (validator === void 0) { validator = null; }
    if (storeInvalidValue === void 0) { storeInvalidValue = true; }
    var validate = validator !== null;
    var errors = validate ?
        validator(value) : __assign({}, NoFieldError);
    draft_errors[field] = errors;
    return false ||
        !validate ||
        storeInvalidValue ||
        isFieldErrorsValid(errors);
}
function setStateField(draft_state, field, value, validator, storeInvalidValue) {
    if (validator === void 0) { validator = null; }
    if (storeInvalidValue === void 0) { storeInvalidValue = true; }
    var storeValue = validateAndTestIfStore(draft_state.errors, field, value, validator, storeInvalidValue);
    if (storeValue) {
        setFieldNotValidate(draft_state, field, value);
    }
}
function setEntityField(draft_state, field, value, validator, storeInvalidValue) {
    if (validator === void 0) { validator = null; }
    if (storeInvalidValue === void 0) { storeInvalidValue = true; }
    var storeValue = validateAndTestIfStore(draft_state.errors, field, value, validator, storeInvalidValue);
    if (storeValue) {
        setFieldNotValidate(draft_state.entity, field, value);
    }
}
export { getEntityField, getStateField, setEntityField, setStateField };
